export const getCreditCardType = (creditCardNumber) => {
  if (!creditCardNumber) {
    return false;
  }

  let cardNumber = creditCardNumber?.toString();
  // If the card number is null or empty, return false
  if (typeof cardNumber === 'undefined' || cardNumber.length === 0) {
    return false;
  }

  // Remove all non digit chars just to be safe
  cardNumber = cardNumber.replace(/[^\d]/, '');

  // Check for Visa: length 16, prefix 4.
  const visaRegex = /^4\d{15}$/;
  if (visaRegex.test(cardNumber)) {
    return 'visa';
  }

  // Check for MasterCard: length 16, prefix 51-55.
  const mastercardRegex = /^5[1-5]\d{14}$/;
  if (mastercardRegex.test(cardNumber)) {
    return 'master';
  }

  // Check for MasterCard2: length 16, prefix 2.
  const masterCard2Regex = /^2\d{15}$/;
  if (masterCard2Regex.test(cardNumber)) {
    return 'master';
  }

  // Check for AmericanExpress: length 15, prefix 34 or 37.
  // Example - 378282246310005;
  const amexRegex = /^3[4,7]\d{13}$/;
  if (amexRegex.test(cardNumber)) {
    return 'amex';
  }

  // if we got to here, card number is unsupported, so return empty string
  return false;
};
